import { Injectable } from '@angular/core';
import { Address } from '@checkout-v2/const';
import { select, Store } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CheckoutActions } from '../store/actions';
import { StateWithCustomCheckout } from '../store/checkout-state';
import { CheckoutSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class DeliveryAddressFacade {
  constructor(private store: Store<StateWithCustomCheckout>) {}

  getAddressListState(): Observable<StateUtils.LoaderState<Address[]>> {
    return this.store.pipe(select(CheckoutSelectors.getAddressListState));
  }

  getAddressList(): Observable<Address[]> {
    return this.store.pipe(select(CheckoutSelectors.getAddressList));
  }

  getAddress(id: string): Observable<Address | undefined> {
    return this.getAddressList().pipe(map((list) => list.find((address) => address.id === id)));
  }

  resetSavedAddressList(): void {
    this.store.dispatch(new CheckoutActions.LoadSavedDeliveryAddressListReset());
  }

  getLoading(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.getAddressListLoading));
  }

  getSuccess(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.getAddressListSuccess));
  }

  getActiveAddressId(): Observable<string | undefined> {
    return this.store.pipe(select(CheckoutSelectors.getActiveAddressId));
  }

  getActiveAddress(): Observable<Address | undefined> {
    return this.store.pipe(select(CheckoutSelectors.getActiveAddress));
  }

  selectActiveAddressId(id: string | undefined): void {
    this.store.dispatch(new CheckoutActions.SelectActiveDeliveryAddress(id));
  }

  saveAddress(address: Address): void {
    this.store.dispatch(new CheckoutActions.SaveDeliveryAddress(address));
  }

  editSavedAddress(address: Address): void {
    this.store.dispatch(new CheckoutActions.EditSavedDeliveryAddress(address));
  }

  deleteSavedAddress(id: string): void {
    this.store.dispatch(new CheckoutActions.DeleteSavedDeliveryAddress(id));
  }
}
